import { render, staticRenderFns } from "./SBImmunizations.vue?vue&type=template&id=bb93636e"
import script from "./SBImmunizations.vue?vue&type=script&lang=js"
export * from "./SBImmunizations.vue?vue&type=script&lang=js"
import style0 from "./SBImmunizations.vue?vue&type=style&index=0&id=bb93636e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports